const dummyUserProfile = {
  "id": 3,
  "account": "user1",
  "name": "user1",
  "avatar": "https://loremflickr.com/320/240/avatar/?random=93.29741801910177",
  "cover": "https://loremflickr.com/639/200/landscapepainting/?random=2.8993761011311125",
  "introduction": ". Eaque neque quia delectus. Cupiditate harum non at. Velit soluta ut non in consequuntur sit qui consequuntur. Labore sint minus et magni.",
  "tweetCount": 10,
  "followingCount": 0,
  "followerCount": 0,
  "isFollowing": false
}
export {dummyUserProfile}
